"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFilterTypeProps = void 0;
const buildFilterTypeProps = props => (props === null || props === void 0 ? void 0 : props.filterType) === 'manual' ? {
  filterType: 'manual',
  manualFilterButtonProps: props.manualFilterButtonProps
} : {
  filterType: 'auto'
};
exports.buildFilterTypeProps = buildFilterTypeProps;